import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class ProductBulkUploadService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }  
  constructor(private http: HttpClient) { }

  getProductMasterData(): Observable<any[]> {
    // return this.http.get<any[]>(this.apiUrl + "getProductMasterData");
    return this.http.get<any[]>(this.baseUrl + "Product/GetProductMasterData");
  }

  uploadMasterData(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.apiUrl + "uploadMasterData", data);
    return this.http.post<any[]>(this.baseUrl + "Product/UploadMasterData", data);
  }

  uploadMasterDataPlantModel(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + "PlantModal/GetPlantMasterData",
      data
    );
  }

  // getCilMasterData() {
  //   return this.http.get<any[]>(this.apiUrl + 'getCilMasterData');
  // }

  uploadCilMasterData(data: any): Observable<any[]> {
    // return this.http.post<any[]>('http://localhost:3000/api/' + 'uploadCilMasterData', data);
    // return this.http.post<any[]>(this.apiUrl + 'uploadCilMasterData', data);
    return this.http.post<any[]>(this.baseUrl + 'cil_bulkupload/UploadCilMasterData', data);
  } 
  
  getExcel(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'PlantModal/GetPlantModelExcel',
      data
    );
  }
  uploadDTMasterData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DTBulkUpload/UploadDTMasterData', data);
  } 

  getDTMasterData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DTBulkUpload/GetDTMasterData', data);
  }
  getProductDetailData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + "Product/GetProductDetail", data);
  }
}
